var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 748.164,
    height: 651.933,
    viewBox: "0 0 748.164 651.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153",
    transform: "translate(-1252.774 -2735.06)",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1007",
    "data-name": "Trazado 1007",
    d: "M1933.188,2875.435l-256.852-128.313a111.679,111.679,0,0,0-99.037.034l-256.771,128.282a111.516,111.516,0,0,0-67.253,102.455V3288.8a97.591,97.591,0,0,0,146.1,84.781l93.717-46.693a23.013,23.013,0,0,0,10.263-31.006h0a23.013,23.013,0,0,0-30.789-10.191l-94.348,47.008-1.329.715a50.581,50.581,0,0,1-59.727-6.033c-11.751-10.482-17.86-25.938-17.86-41.686V2977.893a65.569,65.569,0,0,1,39.94-60.4l258.56-129.123a65.685,65.685,0,0,1,58.046-.038l257.36,128.576,1.271.587a65.559,65.559,0,0,1,39.936,60.4v308.013c0,15.733-6.152,31.156-17.935,41.583a50.652,50.652,0,0,1-59.652,5.927l-.91-.454c-.147-.078-.266-.189-.416-.262l-189.136-94.235-2.441-1.216h0l-33.646-16.762c-13.862-6.907-50.552-24.686-83.094-40.375l.025-.013-45.713-22.435-10.277-5.191a8.235,8.235,0,0,1-4.522-7.351v-90.857a13.364,13.364,0,0,1,8.146-12.316l106.106-52.966a13.477,13.477,0,0,1,11.752-.036l105.292,52.6.888.4a13.857,13.857,0,0,1,8.146,12.626v105.788c0,11.083,7.485,21.3,18.381,23.327a22.779,22.779,0,0,0,27.136-22.349V3054.265a58.88,58.88,0,0,0-35.113-53.891l-104.457-52.18a59.15,59.15,0,0,0-52.3.034l-104.377,52.146a58.879,58.879,0,0,0-35.122,53.893v92.81a53.256,53.256,0,0,0,33.378,49.331c7.728,4.455,7.329,3.723,17.566,8.691,15.722,7.63,31.492,15.124,47.263,22.613,23.16,11.007,47.112,22.387,70.367,33.972l224.6,111.9a97.587,97.587,0,0,0,146.1-84.78v-310.91A111.525,111.525,0,0,0,1933.188,2875.435Z",
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomIcon);
export default __webpack_public_path__ + "static/media/bottom-icon.510c3ecdd4c5db7b2bac0044468e0279.svg";
export { ForwardRef as ReactComponent };